import axios from 'axios'
const loginAPI = async (data) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_API_URL + '/api/v1/login',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: data
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};


const VerifyToken = async (data) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_API_URL + '/api/v1/login/verify',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization: 'bearer ' + localStorage.getItem('accessToken')
        },
    };
    await axios(config)
        .then((res) => {
            response = res;

        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};

export {
    loginAPI,
    VerifyToken
};